import TeamsGroupsPanel from '../components/teams-groups-panel';

export default class TeamsGroupsFlyoutController {
  /* @ngInject */
  constructor($scope) {
    $scope.TeamsGroupsPanel = TeamsGroupsPanel;
  }
}
